export default __webpack_public_path__ + "static/media/iqrf-alliance-member-2023-blue.5451987e.svg";